import { ICommonVipDiscountNotice } from '~/api/converters/global/common/VipDiscountNotice/index.type'
import { styled } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'

const GoldText = styled.span`
  color: ${({ theme }) => theme.color.yagold200};
`
const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`
const Wrapper = styled.div`
  position: relative;
  margin-top: 0.4rem;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 0.2rem;
  align-items: center;
  border-radius: 0.2rem;
  padding: 0 0.5rem;
  background-color: ${({ theme }) => theme.color.black_op80};
  color: ${({ theme }) => theme.color.white};
  ${Typography('badge').bold};
  height: 2rem;

  ::before {
    content: '';
    display: inline-block;
    position: absolute;
    border-left: 0.4rem solid transparent;
    border-right: 0.4rem solid transparent;
    right: 2rem;
    top: -0.4rem;
    border-bottom: 0.4rem solid ${({ theme }) => theme.color.black_op80};
  }

  & > img {
    position: relative;
  }

  & > span {
    margin-top: -0.2rem;
  }
`

type Props = ICommonVipDiscountNotice & {
  className?: string
}

const VipDiscountNotice = ({ totalDiscountPriceText, className }: Props) => {
  if (!totalDiscountPriceText) return null

  return (
    <Container>
      <Wrapper className={className}>
        <img
          src={'https://yaimg.yanolja.com/joy/sunny/static/images/icon_class_gold_symbol.png'}
          width={10}
          height={10}
          alt="Gold Class 로고"
        />
        <img
          src={'https://yaimg.yanolja.com/joy/sunny/static/images/icon_class_gold_text.png'}
          width={24}
          height={10}
          alt="Gold"
        />
        <GoldText>특가</GoldText>
        <span>{totalDiscountPriceText} 할인받았어요.</span>
      </Wrapper>
    </Container>
  )
}

export default VipDiscountNotice
